export default {
  user: null,
  about: {
    title: "About",
    text:
      "As Jorify, Joris Hubers introduces himself as a versatile animator with a specialization in product visualization.\n" +
      "\n" +
      "With a passion for 3D Animation, I am happy to help you convert your products into clear, smooth animations.",
  },
  projects: [
    {
      name: "Moonlamp",
      first_line: "Moon",
      second_line: "lamp",
      slug: "moonlamp",
      image: "images/moonlamp.png",
      id: 1,
      description:
        "This short animation demonstrates how to use the Moon lamp designed by Verner Panton. See how to adjust the light and explore the various styles and colors available.",
      label: "Communicate movement",
      videoOptions: {
        autoplay: true,
        controls: true,
        loop: "loop",
        muted: false,
        fluid: true,
        poster: require("@/assets/images/moonlamp.png"),
        sources: [
          {
            src: require("@/assets/videos/moonlamp.mp4"),
            type: "video/mp4",
          },
        ],
      },
      details: [
        {
          name: "Fluid simulation",
          image: "images/lemon_and_mint_1.png",
          id: 1,
          description:
            "To make the splash i had to make a fluid simulation. This is takes a long time because the computer must simulate the fluid that makes the splash for every frame. It needs to calculate the objects in its way and how the fluid would interact with it. This makes it hard to tweak it just write because you have to wait a few minutes or longer to see the results. ",
        },
        {
          name: "Happy little mistakes",
          image: "images/lemon_and_mint_2.png",
          id: 2,
          description:
            "What makes CG different is that you get more control. You start with nothing, everything you put in was your choice there are never “happy little mistakes”. If you put in a cube or a sphere these wil be te smoothest objects that exist. This makes the images you make look fake, to make it seem real you need to put in the “mistakes” your self. ",
        },
      ],
    },
    {
      name: "We make pans",
      first_line: "We make",
      second_line: "pans",
      slug: "we-make-pans",
      image: "images/we_make_pans.png",
      id: 2,
      description:
        "Each shape represents a product crafted by this imaginative company. To bring these products to life, I chose to animate each one. The sound design serves to accentuate the weight and robustness of the cast iron pans, creating an immersive experience.",
      label: "Shape and product",
      videoOptions: {
        autoplay: true,
        controls: true,
        loop: "loop",
        muted: false,
        fluid: true,
        poster: require("@/assets/images/we_make_pans.png"),
        sources: [
          {
            src: require("@/assets/videos/we_make_pans.mp4"),
            type: "video/mp4",
          },
        ],
      },
    },
    {
      name: "Cameralens",
      first_line: "Camera",
      second_line: "Lens",
      slug: "cameralens",
      image: "images/cameralens.png",
      id: 3,
      description:
        "This exploded view serves as a compelling example of why computer generated video excels in showcasing your product. Beyond offering a photorealistic representation, it also effectively communicates the intricate details of the inner workings, providing a comprehensive visual experience.",
      label: "Exploded view",
      videoOptions: {
        autoplay: true,
        controls: true,
        loop: "loop",
        muted: false,
        fluid: true,
        poster: require("@/assets/images/cameralens.png"),
        sources: [
          {
            src: require("@/assets/videos/cameralens.mp4"),
            type: "video/mp4",
          },
        ],
      },
    },
    {
      name: "Coffee pod",
      first_line: "Coffee",
      second_line: "pod",
      slug: "coffee",
      image: "images/coffee.png",
      id: 4,
      description:
        "Your refined taste elevates every experience. To capture the essence of this exquisite taste, I envisioned something grand. Picture a cascade of coffee, a downpour of flavor, embodying the sensation when that first sip awakens your senses at the start of each day.",
      label: "Visualize taste",
      videoOptions: {
        autoplay: true,
        controls: true,
        loop: "loop",
        muted: false,
        fluid: true,
        poster: require("@/assets/images/coffee.png"),
        sources: [
          {
            src: require("@/assets/videos/coffee.mp4"),
            type: "video/mp4",
          },
        ],
      },
    },
    {
      name: "brouwerij 't ij",
      first_line: "drink",
      second_line: "'tij",
      slug: "brouwerij-tij",
      image: "images/bier.png",
      id: 5,
      description:
        "Brouwerij 't IJ, a Dutch brewery aptly named 't IJ, meaning 'the egg,' inspired the animated inclusion of this symbolic element. Injecting humor and embracing a lively pace, the animation captures the essence of the brewery, where every aspect, even the egg, contributes to the delightful and fast-paced experience.",
      label: "The egg",
      videoOptions: {
        autoplay: true,
        controls: true,
        loop: "loop",
        muted: false,
        fluid: true,
        poster: require("@/assets/images/bier.png"),
        sources: [
          {
            src: require("@/assets/videos/bier.mp4"),
            type: "video/mp4",
          },
        ],
      },
    },
  ],
  image_projects: [
    {
      name: "Lemon and mint",
      first_line: "lemon",
      second_line: "mint",
      slug: "lemon and mint",
      image: "images/lemon_and_mint_0.png",
      images: [
        {
          path: require("@/assets/images/lemon_and_mint_3.png"),
        },
        {
          path: require("@/assets/images/lemon_and_mint_1.png"),
        },
        {
          path: require("@/assets/images/lemon_and_mint_2.png"),
        },
        {
          path: require("@/assets/images/Lemon_and_Mint_ViewportSolid.png"),
        },
      ],
      id: 6,
      description:
        "Producing the splash involved a detailed fluid simulation, a time-intensive process demanding precision. The computer diligently simulates fluid dynamics for each frame, considering obstacles and calculating intricate interactions. Adjusting the simulation becomes a practice in patience, as waiting is essential to observe the nuanced results owing to the complex calculations involved.",
      label: "Fluid simulation",
    },
    {
      name: "Product vizualisation",
      first_line: "Product",
      second_line: "Viz",
      slug: "Product vizualisation",
      image: "images/lipstick_and_perfume_0.png",
      images: [
        {
          path: require("@/assets/images/lipstick_and_perfume_1.png"),
        },
        {
          path: require("@/assets/images/AirPods_1.png"),
        },
        {
          path: require("@/assets/images/Boxje_1.png"),
        },
        {
          path: require("@/assets/images/Boxje_2.png"),
        },
      ],
      id: 7,
      description:
        "I specialize in product visualization, seamlessly integrating logos onto various items. This not only demonstrates my ability to enhance products with your logo but also highlights my skill in creating authentic and visually compelling product visualizations.",
      label: "Product visualization",
    },
  ],
};
